var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.242 40.242"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 3,
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.121 38.121 37-36",
    "data-name": "Line 28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.121 38.121-37-36",
    "data-name": "Line 29"
  }))));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS4yNDIgNDAuMjQyIj4KICA8ZyBkYXRhLW5hbWU9Ikdyb3VwIDUiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMyI+CiAgICA8cGF0aCBkYXRhLW5hbWU9IkxpbmUgMjgiIGQ9Ik0yLjEyMSAzOC4xMjFsMzctMzYiLz4KICAgIDxwYXRoIGRhdGEtbmFtZT0iTGluZSAyOSIgZD0iTTM5LjEyMSAzOC4xMjFsLTM3LTM2Ii8+CiAgPC9nPgo8L3N2Zz4=";